<div class="sidebar-container">
  <div class="buttons-container">
    <abc-button
      *ngFor="let button of controlButtons"
      class="control-button"
      [class]="button.active ? 'active' : ''"
      (click)="button.action()"
      [stylingMode]="'text'"
      type="normal"
      [icon]="button.icon"
      [text]="button.text"
      [visible]="button.visible"
    ></abc-button>
  </div>
</div>
